import {useCallback, useState} from 'react'
import { useAPI } from '../hoc/useAPI';


export const useGetGlassesWork=()=>{
 const ENDPOINTS = useAPI()
    const [glassWorksData,setData]=useState<any[]>([])
    const [glassWorksLoading,setIsLoading]=useState(false)
    const [glassWorksError,setError]=useState('')
const getGlassesWorks=useCallback((page:number)=>{
    setIsLoading(true)
ENDPOINTS.glassWorks()
        .index({page,page_size:1000,sort_direction:'ASC',sort_field:35})
        .then((res:any)=>{
          
            if (res.data && res.data.data && res.data.data.glass_works) {
                setData (res.data.data.glass_works)
                setIsLoading(false)
            }
            else {
                setData([])
                setIsLoading(false)
            }
        })
        .catch((err:any)=>{
            setIsLoading(false)
            setError(err)
        })
  
},[ENDPOINTS])
    return {getGlassesWorks,glassWorksLoading,glassWorksError,glassWorksData}
}